import React from "react";
import ReactToggle from "react-toggle";
import cx from "classnames";
import s from "./toggle.scss";

export default class Toggle extends React.Component {
  updateValue(e) {
    let newValue;
    if (this.props.reverse) {
      newValue = !e.target.checked;
    } else {
      newValue = !!e.target.checked;
    }

    this.props.onChange({ [this.props.name]: newValue });
  }

  render() {
    const { className, reverse, name, disabled, hint, checked, label, errors } = this.props;

    let toggleStatus = checked;
    if (reverse) {
      toggleStatus = !checked;
    }

    return (
      <div
        className={cx(className, s.inputContainer, {
          [s.labelHint]: hint,
          [s.withErrors]: errors,
          [s.disabled]: disabled
        })}
      >
        <div className={s.wrapLabel}>
          <label className={s.label} htmlFor={name}>
            {label || name.replace("_", " ")}
          </label>
          {hint && <div className={s.hint}>{hint}</div>}
        </div>

        <ReactToggle
          disabled={disabled}
          checked={toggleStatus}
          icons={false}
          onChange={this.updateValue.bind(this)}
        />
      </div>
    );
  }
}
